var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / ER") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-ER",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#29C53F",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#579DED",
    mask: "url(#mask-2)",
    x: 0,
    y: 10,
    width: 28,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#F42D56",
    mask: "url(#mask-2)",
    points: "0 20 28 10 0 0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-87",
    stroke: "#FFC63C",
    strokeWidth: 1.33333333,
    mask: "url(#mask-2)",
    cx: 8.66666667,
    cy: 10,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-88",
    fill: "#FFC63C",
    mask: "url(#mask-2)",
    cx: 8,
    cy: 8.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-88",
    fill: "#FFC63C",
    mask: "url(#mask-2)",
    cx: 9.33333333,
    cy: 9.33333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-88",
    fill: "#FFC63C",
    mask: "url(#mask-2)",
    cx: 8.66666667,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-88",
    fill: "#FFC63C",
    mask: "url(#mask-2)",
    cx: 8,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-88",
    fill: "#FFC63C",
    mask: "url(#mask-2)",
    cx: 9.33333333,
    cy: 10.6666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-88",
    fill: "#FFC63C",
    mask: "url(#mask-2)",
    cx: 8,
    cy: 11.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-88",
    fill: "#FFC63C",
    mask: "url(#mask-2)",
    cx: 9.33333333,
    cy: 12,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr);
export default __webpack_public_path__ + "static/media/ER.0194d6874fa622b99db5bd61716d8473.svg";
export { ForwardRef as ReactComponent };